module.exports = __webpack_public_path__ + "img/Asian_Quinoa_Bowl_Ginger_Shrimp.8ccc4f12.jpg";